"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const StyledMemberButton = (0, styled_components_1.default)(ui_1.BaseButton) `
  margin: auto 0 auto 20px;
  padding: 2px 10px;

  font-size: 12px;

  color: ${({ $color, theme }) => ($color ? $color : theme.textPlaceholder)};
  background-color: ${({ $backgroundColor, theme }) => $backgroundColor ? $backgroundColor : theme.text};
`;
exports.default = StyledMemberButton;
